<template>
    <Table
        disabled-hover
        :max-height="configuration.height"
        :height="configuration.height"
        border
        :data="rows"
        :columns="columns"
        :loading="loading"
        class="overflow-visible"
        @on-sort-change="handleSort"
        no-data-text="No instances available."
    >
        <template slot-scope="{ row }" slot="task">
            <activity-link :id="row.id" :stop-propagation="true">
                <span slot="inner">{{ row.title }}</span>
            </activity-link>
        </template>
        <template slot-scope="{ row }" slot="account">
            <account-link :id="row.account.id" :stop-propagation="true">
                <span slot="inner">{{ row.account.name }}</span>
            </account-link>
        </template>
        <template slot-scope="{ row }" slot="entity_playbook">
            <entity-playbook-link
                :id="row.entity_playbook_id"
                :stop-propagation="true"
            >
                <span slot="inner">{{
                    row.playbook_action.playbook.name
                }}</span>
            </entity-playbook-link>
        </template>
        <template slot-scope="{ row }" slot="status">
            <task-status :status-id="row.status_id"></task-status>
        </template>
        <template slot-scope="{ row }" slot="created_at">
            <formatted-date
                :value="row.created_at"
                format="ll"
            ></formatted-date>
        </template>
        <template slot-scope="{ row }" slot="due_at">
            <formatted-date :value="row.due_at" format="ll"></formatted-date>
        </template>
        <template slot-scope="{ row }" slot="completed_at">
            <formatted-date
                :value="row.completed_at"
                format="ll"
            ></formatted-date>
        </template>
        <template slot-scope="{ row }" slot="skipped">
            <formatted-date
                :value="row.completed_at"
                format="ll"
            ></formatted-date>
        </template>
    </Table>
</template>

<script>
export default {
    props: {
        configuration: {
            type: Object,
            default() {
                return {};
            },
        },
        tasks: Array,
        loading: Boolean,
        selectedColumns: {
            type: Array,
            default: function() {
                return [];
            },
        },
    },
    data() {
        return {
            availableColumns: [
                {
                    title: "Task",
                    slot: "task",
                    key: "task",
                    sortable: "custom",
                },
                {
                    title: "Playbook",
                    slot: "entity_playbook",
                    key: "playbook",
                    sortable: "custom",
                },
                {
                    title: "Account",
                    slot: "account",
                    key: "organization",
                    sortable: "custom",
                },
                {
                    title: "Status",
                    align: "center",
                    slot: "status",
                    key: "status_id",
                    sortable: "custom",
                },
                {
                    title: "Created",
                    align: "center",
                    slot: "created_at",
                    key: "created_at",
                    sortable: "custom",
                },
                {
                    title: "Due at",
                    align: "center",
                    slot: "due_at",
                    key: "due_at",
                    sortable: "custom",
                },
                {
                    title: "Completed",
                    align: "center",
                    slot: "completed_at",
                    key: "completed_at",
                    sortable: "custom",
                },
                {
                    title: "Skipped",
                    align: "center",
                    slot: "skipped",
                    key: "completed_at",
                    sortable: "custom",
                },
            ],
        };
    },
    computed: {
        rows() {
            return this.tasks;
        },
        columns() {
            /**
             * If none are selected, return all
             */
            if (!this.selectedColumns.length) {
                return this.availableColumns;
            }

            /**
             * Otherwise, return the AVAILABLE contained in SELECTED
             */
            return _.filter(this.availableColumns, (column) => {
                /**
                 * Test where available IN selected array
                 */
                return (
                    _.findIndex(this.selectedColumns, (selectedColumn) => {
                        return (
                            column.slot == selectedColumn ||
                            column.key == selectedColumn
                        );
                    }) > -1
                );
            });
        },
    },
    methods: {
        handleSort(arg) {
            this.$emit("sort", arg);
        },
    },
    components: {
        AccountLink: function() {
            return import("@/js/components/partials/account-link");
        },
        ActivityLink: function() {
            return import("@/js/components/partials/activity-link");
        },
        EntityPlaybookLink: function() {
            return import("@/js/components/partials/entity-playbook-link");
        },
        EntityPlaybookLink: function() {
            return import("@/js/components/partials/entity-playbook-link");
        },
        TaskStatus: function() {
            return import("@/js/components/partials/task-status");
        },
        FormattedDate: function() {
            return import("@/js/components/partials/formatted-date");
        },
    },
};
</script>
